<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.contentWidth === "boxed" ? "container p-0" : null },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/layout-full/LayoutFull.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_app_config_useAppConfig from '@core/app-config/useAppConfig';
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  setup() {
    const {
      contentWidth
    } = core_app_config_useAppConfig();
    return {
      contentWidth
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/layout-full/LayoutFull.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

